import React from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

const PaginationComponent = (props) => {
  const currentPage = Math.max(1, Number(props.page) || 1);
  const totalPages = Math.max(1, Math.ceil(Number(props.numOfPages) || 1));

  const getVisiblePages = () => {
    const pages = new Set([1, totalPages]);
    const windowSize = 2;

    for (
      let page = currentPage - windowSize;
      page <= currentPage + windowSize;
      page++
    ) {
      if (page > 1 && page < totalPages) pages.add(page);
    }

    return [...pages].sort((a, b) => a - b);
  };

  const visiblePages = getVisiblePages();

  return (
    <div
      className="d-flex flex-wrap align-items-center justify-content-between"
      style={{ gap: "1rem" }}
    >
      <div className="text-muted small">
        Page {currentPage} of {totalPages}
      </div>

      <Pagination
        className="pagination mb-0"
        listClassName="mb-0 flex-wrap justify-content-end"
        style={{ gap: "0.25rem" }}
      >
      <PaginationItem className={currentPage < 2 ? "disabled" : ""}>
        <PaginationLink tabIndex="-1" onClick={props.handlePrevious}>
          <i className="fa fa-angle-left" />
          <span className="sr-only">Previous</span>
        </PaginationLink>
      </PaginationItem>

      {visiblePages.map((pageNumber, index) => (
        <React.Fragment key={pageNumber}>
          {index > 0 && pageNumber - visiblePages[index - 1] > 1 && (
            <PaginationItem disabled>
              <PaginationLink>...</PaginationLink>
            </PaginationItem>
          )}

          <PaginationItem
            className={pageNumber === currentPage ? "active" : ""}
          >
            <PaginationLink
              onClick={() => props.handlePageChange(pageNumber - 1)}
            >
              {pageNumber}
            </PaginationLink>
          </PaginationItem>
        </React.Fragment>
      ))}

      <PaginationItem
        className={currentPage >= totalPages ? "disabled" : ""}
      >
        <PaginationLink onClick={props.handleNext}>
          <i className="fa fa-angle-right" />
          <span className="sr-only">Next</span>
        </PaginationLink>
      </PaginationItem>
      </Pagination>
    </div>
  );
};

export default PaginationComponent;
